export default __webpack_public_path__ + "static/img_768-cb72f853d0c5787ec8c38037675bfa94.jpg";